import { defineComponent as _defineComponent } from 'vue'
import { type PropType, computed, ref, watch } from 'vue'

import appStore from '../store/app'
import itemStore from '../store/item'

import NcAppContent from '@nextcloud/vue/dist/Components/NcAppContent.js'
import NcAppContentList from '@nextcloud/vue/dist/Components/NcAppContentList.js'
import NcAppContentDetails from '@nextcloud/vue/dist/Components/NcAppContentDetails.js'
import NcEmptyContent from '@nextcloud/vue/dist/Components/NcEmptyContent.js'

import TextIcon from 'vue-material-design-icons/Text.vue'

import { FeedItem } from '../types/FeedItem'

import FeedItemDisplayList from './feed-display/FeedItemDisplayList.vue'
import FeedItemDisplay from './feed-display/FeedItemDisplay.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentTemplate',
  props: {
	items: {
		type: Array as PropType<Array<FeedItem>>,
		required: true,
	},
	fetchKey: {
		type: String,
		required: true,
	},
},
  emits: ["load-more"],
  setup(__props, { emit }: { emit: ({(event: 'load-more'): void}), expose: any, slots: any, attrs: any }) {


/**
 * This component uses vue's composition api format,
 * for more information, see https://vuejs.org/guide/extras/composition-api-faq.html
 */





const showDetails = ref(false)

const contentElement = ref()

const layout = computed(() => {
	switch (appStore.getters.splitmode(appStore.state)) {
	case '1':
		return 'horizontal-split'
	case '2':
		return 'no-split'
	case '0':
	default:
		return 'vertical-split'
	}
})

const selectedFeedItem = computed(() => {
	return itemStore.getters.selected(itemStore.state)
})

watch(selectedFeedItem, (newSelectedFeedItem) => {
	if (newSelectedFeedItem) {
		contentElement.value?.scrollTo(0, 0)
	} else {
		showItem(false)
	}
})

/**
 * set showDetails value
 *
 * @param {boolean} value Show or hide item
 *
 */
function showItem(value) {
	showDetails.value = value
}


return { __sfc: true,emit, showDetails, contentElement, layout, selectedFeedItem, showItem, NcAppContent, NcAppContentList, NcAppContentDetails, NcEmptyContent, TextIcon, FeedItemDisplayList, FeedItemDisplay }
}

})